@if (showImage) {
	<img
		#img
		[src]="url | cdn: nativeElement"
		alt="&nbsp;"
		(load)="onLoad(img)"
		(error)="onError()"
	/>
} @else {
	@if (useInitials) {
		<span class="initials">
			{{ initials }}
		</span>
	} @else {
		<ng-content></ng-content>
	}
}
